import { mapState } from 'vuex'
let loadingUI = null
export default {
  computed: {
    ...mapState(['globalLoading'])
  },
  watch: {
    globalLoading: function (loadingList) {
      const isLoading = loadingList.length
      if (isLoading && !loadingUI) {
        loadingUI = this.$globalLoading.show()
      } else if (!isLoading && loadingUI) {
        this.$globalLoading.close()
        loadingUI = null
      }
    }
  }
}
